export default __webpack_public_path__ + "static/media/mask.9f8e5d65.svg";